import {len}  from './helpers';

export default function (length) {
    return function (value) {
        return value ? len(value) === length : false
    }
}
